import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "../components/SEO";
import { findGroup } from "../data/services";

// Temporary stub for routes not yet built (hubs, service pages, quiz, etc.).
// The homepage ships first; these get real templates in WP3 to WP5.
export default function Placeholder() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/\//g, "");
  const group = findGroup(pathname.split("/").filter(Boolean)[0]);
  const title = group ? group.title : "This page";

  return (
    <>
      {/* Catch-all route. Serves unbuilt stubs and any unknown URL, so it must
          never be indexed: "follow" so link equity still flows to real pages. */}
      <SEO title={title} path={pathname} noindex />
      <section className="container-page py-24 text-center">
        <p className="eyebrow">Coming soon</p>
        <h1 className="mt-3 text-3xl font-bold text-acblue sm:text-4xl">
          {title}
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-acBlack/70">
          This page is part of the next build phase. The homepage is live for
          review now. Route: <code className="text-acAccent">/{slug}</code>
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" className="btn-ghost">
            <ArrowLeft className="h-4 w-4" />
            Back home
          </Link>
          <Link to="/book-consultation/" className="btn-primary">
            Book a consultation
          </Link>
        </div>
      </section>
    </>
  );
}
